export const DownloadCSV = (prefix: string) => {
  const component = () => null;
  component['displayName'] = `${prefix}.DownloadCSV`;

  return component;
};
